import useChangeRoute from './useChangeRoute';

export default useChangeRoute;
